export type FounderRole = {
  id: string
  label: string
  title: [string, string]
  tag: string
  quote: string
  revenue: string
  move: string
  color: string
  suit: string
  prop: 'case' | 'mug' | 'laptop' | 'notebook'
  share: string
}

// Original, fictional personas. No names, email addresses or user IDs in share links.
export const founderRoles: readonly FounderRole[] = [
  {
    id: 'visionary', label: 'Visionary Founder', title: ['Visionary', 'Founder'],
    tag: 'SELF-APPOINTED', quote: 'The vision is clear. The business model is a work in progress.',
    revenue: 'Pre-revenue. Post-confidence.', move: 'Put one tiny idea online today.',
    color: '#f5e76c', suit: '#3f5063', prop: 'case',
    share: 'I appointed myself Visionary Founder. My valuation is imaginary. My confidence is a concern. Make your own LARPup card.',
  },
  {
    id: 'stealth', label: 'Stealth Mode CEO', title: ['Stealth Mode', 'CEO'],
    tag: 'PRODUCT CLASSIFIED', quote: 'So stealth even the product does not know it exists.',
    revenue: 'Also in stealth mode.', move: 'Show one person what you are making.',
    color: '#d6caf2', suit: '#55536b', prop: 'notebook',
    share: 'LARPup made me a Stealth Mode CEO. So stealth even the product does not know it exists. There is probably a title for you too.',
  },
  {
    id: 'thought-leader', label: 'AI Thought Leader', title: ['AI Thought', 'Leader'],
    tag: 'THOUGHTS LOADING', quote: 'Read one thread. Ready for the keynote.',
    revenue: 'Paid in exposure, apparently.', move: 'Make a useful demo before the next post.',
    color: '#ccebdd', suit: '#417b6f', prop: 'mug',
    share: 'Read one thread. Ready for the keynote. LARPup has officially made me an unofficial AI Thought Leader. Make your own card.',
  },
  {
    id: 'almost-founder', label: 'Serial Almost-Founder', title: ['Serial Almost-', 'Founder'],
    tag: 'IDEA NUMBER 47', quote: 'Owns the domain. Still negotiating with the idea.',
    revenue: 'Currently an outgoing payment.', move: 'Finish the smallest thing. Not a new logo.',
    color: '#f5d7c6', suit: '#925e42', prop: 'laptop',
    share: 'LARPup called me a Serial Almost-Founder. Owns the domain. Still negotiating with the idea. I feel seen. Make your own card.',
  },
]

export function getFounderRole(id: string | null): FounderRole {
  return founderRoles.find(role => role.id === id) ?? founderRoles[0]
}

export function founderUrl(role: FounderRole, medium: 'share' | 'x' = 'share'): string {
  const url = new URL('https://larpup.com/')
  url.searchParams.set('role', role.id)
  url.searchParams.set('utm_source', medium)
  url.searchParams.set('utm_medium', medium === 'x' ? 'organic_social' : 'card')
  url.searchParams.set('utm_campaign', 'founder_pass')
  // Shared links get a new address every time this changes, so X fetches the current preview image.
  url.searchParams.set('v', '4')
  return url.toString()
}
